
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import descriptor from './DataPreparationAvroHandlingDialogDescriptor.json'
import Timeline from 'primevue/timeline'
export default defineComponent({
    name: 'data-preparation-avro-handling-dialog',
    components: { Dialog, Message, Timeline },
    emits: ['close'],
    props: { visible: { type: Boolean }, title: { type: String }, infoMessage: { type: String }, events: { type: Array } },
    data() {
        return {
            descriptor,
            sec: 0
        }
    },
    mounted() {
        this.sec = 5
    },
    methods: {
        computeLabel() {
            if (this.events?.length === 5) {
                let lastEvent = this.events[this.events.length - 1] as any
                if (lastEvent?.status === 'error') {
                    return this.$t('common.close')
                } else {
                    return this.$t('common.continue') + ' (' + this.sec + ')'
                }
            } else {
                return this.$t('common.continue')
            }
        },
        closeDialog() {
            this.$emit('close')
        },
        handleTimeout() {
            let self = this
            var x = setInterval(function() {
                if (self.sec > 0) {
                    self.sec--
                } else if (self.sec == 0) {
                    clearInterval(x)
                }
            }, 1000)
            setTimeout(() => {
                this.closeDialog()
            }, 5000)
        }
    },
    watch: {
        events: {
            handler(newValue) {
                if (newValue.length === 5) {
                    let lastEvent = newValue[newValue.length - 1] as any

                    if (lastEvent?.status !== 'error') {
                        this.handleTimeout()
                    }
                }
            },
            deep: true
        }
    }
})
